import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet, select, selectAll } from '@neptune/cx/utils';

const gc = new DisposalSet();

registerFragment('chroa-podcast-body', (fragmentElement, config, meta) => {
    // aria-expanded on button needs to change from true to false, viceversa
    // set/remove 'hidden' attribute on content element
    // change button text from view more to view less

    console.log('test run');

    const transcriptAccordions = select<HTMLDivElement>(fragmentElement, '.chroa-resource-body__transcript-button-container');



    if (transcriptAccordions) {
        const toggleButton = select<HTMLButtonElement>(transcriptAccordions, 'button');
        const toggleContent = select<HTMLDivElement>(fragmentElement, '#view-more-sect');

        (gc.register(toggleButton)
            .addListener('click', () => {
                if(toggleButton.getAttribute('aria-expanded') == 'false') {
                    toggleButton.setAttribute('aria-expanded', 'true');
                    toggleButton.innerText = 'View Less';
                    toggleContent.removeAttribute('hidden');
                } else {
                    toggleButton.setAttribute('aria-expanded', 'false');
                    toggleContent.setAttribute('hidden', '');
                    toggleButton.innerText = 'View More';
                }
            })
        );
    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
